// extracted by mini-css-extract-plugin
module.exports = {"container":"ControlsHeader_container__14IQc","title":"ControlsHeader_title___v5kt","controls":"ControlsHeader_controls__21Pod"};